import React from 'react';
import Fourthgrade_k4 from './fourthgrade_k4';
import Fourthgrade_k4_subjects from './fourthgrade_k4_subjects';
const Fourthgrade_k4soc = () => {
  return (
    <div>
      <Fourthgrade_k4 />
    <Fourthgrade_k4_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Social section</h1>
      <h3>English section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Fourthgrade_k4soc;